import { useQuery } from '@tanstack/react-query'

import { fetchWithHeaders } from 'utils'

import { GrapeAPIError, type GrapeAPIErrorType } from './GrapeAPIError'
import { type PaginatedResponse } from './types'
import type { PaySchedule } from '../../types/payroll'

export function useGetPaySchedules (scheduleIds?: string[]) {
  return useQuery<PaginatedResponse<PaySchedule>, GrapeAPIErrorType>({
    queryKey: ['paySchedules'],
    queryFn: async () => {
      const queryParams = scheduleIds && scheduleIds.length > 0 ? `?ids=${scheduleIds.join(',')}` : ''
      const response = await fetchWithHeaders(`/api/web/payroll/pay_schedules${queryParams}`)
      if (!response.ok) {
        const errorJson = await response.json()
        throw GrapeAPIError({
          status: response.status,
          message: errorJson.message,
          errors: errorJson.errors
        })
      }
      return response.json() ?? []
    }

  })
}
